/** Builds Paper sx for StatBlock from interaction + density props. */
import { STATIC_CARD_BORDER_SX } from '@/components/ui/staticCardBorderSx';

export function buildStatBlockSx({ onClick, sx }) {
  return {
    ...STATIC_CARD_BORDER_SX,
    p: 3.5,
    textAlign: 'center',
    mb: 1.5,
    width: onClick ? '100%' : undefined,
    font: onClick ? 'inherit' : undefined,
    cursor: onClick ? 'pointer' : 'default',
    '&:hover': onClick
      ? { borderColor: 'text.secondary', bgcolor: 'background.subtle' }
      : undefined,
    ...sx,
  };
}
